import { render, staticRenderFns } from "./meterReaderManage.vue?vue&type=template&id=385c0361&scoped=true"
import script from "./meterReaderManage.vue?vue&type=script&lang=js"
export * from "./meterReaderManage.vue?vue&type=script&lang=js"
import style0 from "./meterReaderManage.vue?vue&type=style&index=0&id=385c0361&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385c0361",
  null
  
)

export default component.exports